module.exports = __webpack_public_path__ + "static/media/altassd-2.97572a66.jpg";